import Swal from "sweetalert2";
import { Avatar } from "@mui/material";
const SwalMedia = (props) => {
  const { component = "img", isWithBlur = true } = props;

  const handleImageClick = () => {
    Swal.fire({
      title: props.title,
      imageUrl: props.src,
      imageWidth: 800,
      imageHeight: "auto",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      showCloseButton: true,
      padding: "20px",
      preConfirm: () => {
        return true;
      },
    });
  };

  const commonProps = {
    ...props,
    alt: "click to enter swal dialogue",
    onClick: () => handleImageClick(),
  };
  delete commonProps.isWithBlur;

  if (component === "Avatar") {
    return <Avatar {...commonProps} />;
  } else if (component === "img") {
    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: props.width,
          height: props.height,
          overflow: "hidden",
        }}
      >
        {isWithBlur ? (
          <img
            src={props.src}
            alt='blurred background'
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "blur(10px)",
              transform: "scale(1.1)",
            }}
          />
        ) : (
          <></>
        )}
        {/* 原始图片 */}
        <img
          {...commonProps}
          style={{
            position: "relative",
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }
  return null;
};

export default SwalMedia;
